// Session timeout configuration- 1 hour timeout
const INACTIVITY_TIMEOUT = 60 * 60 * 1000; 
const WARNING_TIME = 5 * 60 * 1000; 

let inactivityTimer = null;
let warningTimer = null;

const ACTIVITY_EVENTS = [
  'mousedown',
  'mousemove',
  'keypress',
  'scroll',
  'touchstart',
  'click'
];

export const sessionManager = {
  
  startTracking(onWarning, onTimeout) {    
    this.stopTracking();
    
    warningTimer = setTimeout(() => {
      if (onWarning) onWarning();
    }, INACTIVITY_TIMEOUT - WARNING_TIME);
    
    inactivityTimer = setTimeout(() => {
      if (onTimeout) onTimeout();
    }, INACTIVITY_TIMEOUT);
    
    // Listen for user activity
    ACTIVITY_EVENTS.forEach(event => {
      window.addEventListener(event, this.resetTimer.bind(this, onWarning, onTimeout), true);
    });
  },
  
  resetTimer(onWarning, onTimeout) {
    if (inactivityTimer) clearTimeout(inactivityTimer);
    if (warningTimer) clearTimeout(warningTimer);
    
    warningTimer = setTimeout(() => {
      if (onWarning) onWarning();
    }, INACTIVITY_TIMEOUT - WARNING_TIME);
    
    inactivityTimer = setTimeout(() => {
      if (onTimeout) onTimeout();
    }, INACTIVITY_TIMEOUT);
  },
  
  stopTracking() {
    if (inactivityTimer) clearTimeout(inactivityTimer);
    if (warningTimer) clearTimeout(warningTimer);
    
    ACTIVITY_EVENTS.forEach(event => {
      window.removeEventListener(event, this.resetTimer, true);
    });
    
  },
  
  // Check if token is expired
  isTokenExpired() {
    const token = localStorage.getItem('authToken');
    if (!token) return true;
    
    return false;
  }
};